import { ISubRetailIn } from "../../models/input/agendaApi/ISubRetail";
import * as ApiWithToken from "../callApiWithToken";


const subRetailManagement = {
    getSubRetailInformationListPos: async function(languageId:string){
        return  ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API +  `SubRetail/GetSubRetailInformationList?LanguageID=${languageId}`);
    },
    getRetailList: async function(){
        return  ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API +  `SubRetail/GetRetailList`);
    },
    getTierList: async function(languageId:string){
        return  ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API +  `SubRetail/GetTierList?LanguageID=${languageId}`);
    },
    getFormatList: async function(languageId:string){
        return  ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API +  `SubRetail/GetSubRetailPOSFormatList?LanguageID=${languageId}`);
    },
    insertSubRetail:async function(subRetailInsertIn: ISubRetailIn){
        return ApiWithToken.postApi(process.env.REACT_APP_AGENDAS_API + `SubRetail/CreateSubRetail`, subRetailInsertIn);
    },
    updateSubRetail:async function(subRetailInsertIn: ISubRetailIn){
        return ApiWithToken.putApi(process.env.REACT_APP_AGENDAS_API + `SubRetail/UpdateSubRetail`, subRetailInsertIn);
    },
}
export default subRetailManagement;
